import { v7 as uuidv7 } from 'uuid';
export function generateOperationId() {
    return uuidv7();
}
//# sourceMappingURL=operation.js.map